//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


	import {BASIC} from "@/config/constant"
	import promise from '@/axios/promise'
	import moment from 'moment'

	import {detailData,approveProject,projSapSyncDeal,apprProcSubmit} from '@/api/pm/project';
	import { Toast } from 'mint-ui';

	export default {
		name:'taskDetail',
		data(){
	      return {
	        taskId: this.$route.query.taskId,
	        taskType: this.$route.query.taskType,
	        taskTopic: this.$route.query.taskTopic,
	        showConfirm:this.$route.query.showConfirm,
	        businessKey:this.$route.query.businessKey,
	        taskDefinitionKey:this.$route.query.taskDefinitionKey,
	        taskVisible: false,
	        taskHis:[],
	        selects: [],
	        columns: [/*{
	            title: '账号',
	            name: 'userName',
	            width: 80,
	            align: 'center'
	          },*/
	          {
	            title: '名称',
	            name: 'realName',
	            align: 'center'
	          }
	        ],
	        variables:{},
	        msg:"",
	        Index:0,
	        status:"S",
	        nextTaskDatas:[],

	      	// 主表数据
	      	from:{},
	      	// 合同数据
	      	contData:[],
	      }
		},
		created(){
			// 加载数据
			this.loadData();
		},
		computed:{

		},
		mounted: function(){
		},
		methods:{
			//时间格式化
			dateFormat(date) {
				if (date == undefined) {
					return "";
				}
				return moment(date).format("YYYY-MM-DD");
			},
		    openAlertDialog() {
		        this.taskVisible = true;
		    },
		    closeAlertDialog() {
		    	this.taskVisible = false;
		    },
			// 返回
			goback(){
				// 返回工作台
				//this.$router.push({ name:'workbench'});
        		this.$router.go(-1);
			},
		    // 加载数据
		    loadData(){
		        var condition = {'projId':this.businessKey};
		        detailData(condition).then(response => {
		        	// 数据赋值
	          		this.from = response.projBasicInfo;
	          		this.contData = response.contData;
	          		this.showControl();
		        });
		    },
		    // 界面显隐控制
		    showControl(){
				// 已审批情况
				if(this.taskType === 'done'){
					$(".bottomNav").css('display','none');
				}
		    },
            // 提交
            submitClick(){
                var condition = {projId:this.from.id,pdCode:this.from.pdCode};
                apprProcSubmit(condition).then(response => {
                    if(response.flag === 'S'){
                        // 提交情况下
                        Toast({
                          message: '提交成功！',
                          position: 'middle',
                          duration: 1500,
                          className:'success'
                        });
                        // 返回列表界面
                        this.goback();
                    }else{
                        Toast({
                          message: '提交失败：'+response.msg,
                          position: 'middle',
                          duration: 1500,
                          className:'warning'
                        });
                    }
                });
            },
	      agreeTask:function(){
	        this.status="S";
	        this.variables.status=this.status;
	        if(this.showConfirm==0){
	          this.taskVisible=true;
	          this.getNextTaskDatas();
	        }else{
	          this.completeTask();
	        }     
	      },
	      refuseTask:function(){
	        this.status="E";
	        this.variables.status=this.status;
	        this.taskVisible=true;
	        this.getNextTaskDatas();
	      },
	      completeTask:function(){
	        var map={};
	        map.variables=this.variables;
	        promise({
	          url:BASIC+"/task/completeTaskByTaskId?taskId="+this.taskId+"&msg="+this.msg+"&status="+this.status,
	          method:"post",
	          headers:{"Content-Type": "application/json" },
	          data:JSON.stringify(map),
	        }).then(res=>{
	            if(res.code==0){
	              this.taskVisible=false;
	              // 数据处理
	              this.approveDeal();
	             }else{
	                // Message({message:res.msg,type:"error"});
	             }
	        });
	      },
	      IndexClick:function(index){
	        this.Index=index;
	      },
	      taskConfirm:function(){
	        //获取页面传递过来的变量
	        var map={};
	        //审核意见
	        //循环获取每个任务的办理人和任务主题
	        var topics={};
	        var variables=this.variables;
	        var flag=0;//0正常 1任务配置 2任务主题 3办理人
	        var msg="";
	        $.each(this.nextTaskDatas,function(index,row){
	          var task=row.task;
	          var taskKey=task.taskDefinitionKey;
	          var taskName=task.taskName;
	          var actDicTask= row.actDicTask;
	          if(taskKey!='end'){
	            if(actDicTask==null){
	              flag=1;
	              msg="请配置该流程的"+taskName+"节点任务信息";
	              return;
	            }else if(actDicTask.taskType==null || actDicTask.taskType==''){
	              flag=1;
	              msg="请配置该流程的"+taskName+"节点任务任务类型";
	              return;
	            }else if(actDicTask.userExpKey==null || actDicTask.userExpKey==''){
	              flag=1;
	              msg="请配置该流程的"+taskName+"节点任务办理人方式";
	              return;
	            }else{
	              //设置任务主题
	              var taskTopic=task.taskTopic;
	              if(taskTopic==null || taskTopic==''){
	                flag=2;
	                msg=taskName+"节点任务主题不能为空";
	                return;
	              }
	              topics[taskKey]=taskTopic;
	              //任务办理人
	              var taskType=actDicTask.taskType;
	              var userExpKey=actDicTask.userExpKey;
	              var data =[];
	              var checkedUsers=row.checkedUsers;
	              if(checkedUsers!=null && checkedUsers.length>0){
	                $.each(row.users,function(index,user){
	                  $.each(checkedUsers,function(index1,userIndex){
	                    if(userIndex==index){
	                      data.push(user);
	                    }
	                  });
	                });
	              }
	              if(taskType=='Multi'){
	                if(data==null || data.length==0){
	                  flag=3;
	                  msg=taskName+"节点任务办理人不能为空";
	                  return;
	                }else {
	                  var userVal="";
	                  for (var i = 0; i < data.length; i++) {
	                    var user=data[i];
	                    if(i==0){
	                      userVal+=user.userName;
	                    }else{
	                      userVal=userVal+","+user.userName
	                    }
	                  }
	                  variables[userExpKey]=userVal;
	                }
	              }else{
	                if(data==null || data.length==0){
	                  flag=3;
	                  msg=taskName+"节点任务办理人不能为空";
	                  return;
	                }else if(data.length>1){
	                  flag=3;
	                  msg=taskName+"节点为单人任务";
	                  return;
	                }else{
	                  variables[userExpKey]=data[0].userName;
	                }
	              }
	            }
	          }else{
	            var taskTopic=task.taskTopic;
	            if(taskTopic==null || taskTopic==""){
	              taskTopic="结束"
	            }
	            topics.end=taskTopic;
	          }
	        });
	        if(flag!=0){
	          // Message({message:msg,type:"error"});
	          return;
	        }
	        //任务主题
	        //设置流程办理人
	        map.taskTopics=topics;
	        map.variables=variables;
	        this.taskVisible=false;
	        promise({
	          url:BASIC+"/task/completeTaskByTaskId?taskId="+this.taskId+"&msg="+this.msg+"&status="+this.status,
	          method:"post",
	          headers:{"Content-Type": "application/json" },
	          data:JSON.stringify(map),
	        }).then(res=>{
	            if(res.code==0){
	              this.taskVisible=false;
	              // 数据处理
	              this.approveDeal();
	             }else{
	                // Message({message:res.msg,type:"error"});
	             }
	        });
	      },
	      // 审批通过后的数据处理
	      approveDeal(){
	      	var taskKey = this.taskDefinitionKey;
	      	var data = {'taskId':this.businessKey,'isPass':this.status,'taskKey':taskKey};
	      	approveProject(data).then(response => {
	        	if(response.flag === 'S'){
	              	Toast({
					  message: '操作成功！',
					  position: 'middle',
					  duration: 1500,
					  className:'success'
					});
	        		this.goback();

        			// 调用sap同步接口, 成功情况下，最后一个节点，触发sap同步
			        if(taskKey === 'finApprove' && this.status === 'S'){
			        	var condition = {'ids':this.businessKey};
			            projSapSyncDeal(condition).then(response => {
			              if(response && response.code.toString() !== '0'){
			                Toast({
							  message: '同步SAP失败：'+ response.msg,
							  position: 'middle',
							  duration: 1500,
							  className:'warning'
							});
			              }
			            });
			        }
	        	}else{
	    			Toast({
					  message: '立项数据处理失败：'+response.msg,
					  position: 'middle',
					  duration: 1500,
					  className:'warning'
					});
	        	}
	        });
	      },
	      getTaskTopic:function(task,taskTopicExp){
	        if(task!=null){
	          var commitUser=task.commitUser;
	          if(commitUser==null || commitUser==''){
	            status='F';
	          }
	        }
	        var taskTopic='';
	        if(taskTopicExp==null || taskTopicExp==''){
	          taskTopic=task.processDefinitionName+":"+task.taskName+":"+task.commitUserName;
	        }else{
	          var expArr=taskTopicExp.split(":");
	          for (var i = 0; i < expArr.length; i++) {
	            var exp=expArr[i];
	            if(i==expArr.length-1){
	              if(exp==null || exp==''){
	                continue;
	              }else if(exp=="procName"){
	                taskTopic=taskTopic+task.processDefinitionName;
	              }else if(exp=="taskName"){
	                taskTopic=taskTopic+task.taskName;
	              }else if(exp=="commitUser"){
	                taskTopic=taskTopic+task.commitUserName;
	              }else{
	                var expVal=$("#"+exp).val();
	                if(expVal!=undefined && expVal!=null && expVal!=""){
	                 taskTopic=taskTopic+expVal;
	                }
	              }
	            }else{
	              if(exp==null || exp==''){
	                continue;
	              }else if(exp=="procName"){
	                taskTopic=taskTopic+task.processDefinitionName+":";
	              }else if(exp=="taskName"){
	                taskTopic=taskTopic+task.taskName+":";
	              }else if(exp=="commitUser"){
	                taskTopic=taskTopic+task.commitUserName+":";
	              }else{
	                var expVal=$("#"+exp).val();
	                if(expVal!=undefined && expVal!=null && expVal!=""){
	                  taskTopic=taskTopic+expVal+":";
	                }
	              }
	            }
	          }
	        }
	        return taskTopic;
	      },
	      getNextTaskDatas:function(){
	        var str=JSON.stringify(this.variables);
	        promise({
	          url:BASIC+"/task/getConfirmInfo?taskId="+this.taskId+"&status="+this.status,
	          method:"post",
	          headers:{"Content-Type": "application/json" },
	          data:str
	        }).then(res=>{
	          var code =res.code;
	          if(code==0){
	            this.nextTaskDatas=res.data;
	            var self=this;
	            $.each(this.nextTaskDatas,function(index,row){
	              var taskTpc = '';
                  if(row.actDicTask !== null){
                    taskTpc = row.actDicTask.taskTopic;
                  }
                  var taskTopic=self.getTaskTopic(row.task,taskTpc);
	              row.task.taskTopic=taskTopic;
	            });
	          }else{
	            // Message({message:res.msg,type:"error",duration:1000});
	          }
	         });
	      }
    }
}



// WEBPACK FOOTER //
// ./src/view/pm/project/projApproval.vue